export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "title",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "createdAt",
  },
  {
    Header: "PROGRESS",
    accessor: "expiredAt",
  },
];


